import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e7ffc48a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e7ffc48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ffc48a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7ffc48a')) {
      api.createRecord('e7ffc48a', component.options)
    } else {
      api.reload('e7ffc48a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e7ffc48a&scoped=true&", function () {
      api.rerender('e7ffc48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4u3g1VRDfEo11/JS/comp/SearchFilterTokens.vue"
export default component.exports